export default (products, emailText) => {
  if(emailText) {
    return emailText.replace('REPLACE_PRODUCTS', products.join('\r\n'))
  }
}
